/**
 * A simple set of tabs that allows tab changes to be intercepted and canceled.
 * 
 * edxTabs should be an array of tab objects.  Tab objects have a name property that
 * is displayed in the tab.  The currently selected tab can be specified by setting
 * selected: true.  Optional CSS ids for tabs can be defined by adding a cssIds property that contains
 * an array of ids.
 * 
 * [{
 *  cssIds: ['tabOne'],
 *  name: 'Tab One'
 * },
 * {
 *  cssIds: ['tabTwo'],
 *  name: 'Tab Two',
 *  selected: true
 * }]
 * 
 * This directive doesn't explicitly manage visibility of content associated with a tab.
 * Content associated with a tab can be hidden/shown by monitoring the selected
 * property of a tab object.
 * 
 * Before a tab change this component attaches a changeCancelers array to the chosen tab.
 * The chosen tab is passed to edxBeforeTabChange so listeners can push an Rx.Observable
 * to the changeCancelers array.
 * 
 * The Rx.Observable should just complete to proceed with the tab change. It should emit
 * any value and the complete to cancel the tab change.
 * 
 *         $scope.beforeTabChange = function (tab) {
 *          var canceler = new Rx.AsyncSubject();
 *
 *           modal.result.then(
 *           function () {
 *              canceler.onCompleted();
 *             },
 *             function () {
 *               canceler.onNext();
 *               canceler.onCompleted();
 *             }
 *           );
 *
 *           tab.changeCancelers.push(canceler);
 *         }
 *       };
 *
 */
angular.module('EdxCommonModule')
  .directive('edxTabs', function () {
    return {
      restrict: 'E',
      scope: {
        edxTabs: '=',
        edxBeforeTabChange: '&',
        edxAfterTabChange: '&'
      },
      templateUrl: '/resources/components/common/tabs/edx-tabs.directive.html',
      controller: [
          '$scope',
        function(
          $scope
        ) {

          var selectTab = function (tab) {
            _.each($scope.edxTabs, function (tab1) {
              tab1.selected = false;
            });

            tab.selected = true;
            $scope.edxAfterTabChange({
              tab: tab
            });
          };

          $scope.onTabClick = function (tab) {
            if (tab.selected) {
              return;
            }

            tab.changeCancelers = [];
            $scope.edxBeforeTabChange({
              tab: tab
            });

            if (tab.changeCancelers.length) {
              var canceler = Rx.Observable.combineLatest(tab.changeCancelers);
              var cancelled = false;

              canceler.subscribe(function () {
                cancelled = true;
              }, function () {
                // error handler means don't cancel                
              }, function () {
                if (!cancelled) {
                  selectTab(tab);
                }
              });
            } else {
              selectTab(tab);
            }
          };
        }] // controller
    };
  });
